import {
  ANY,
  LAST_POSITION,
  FIRST_POSITION,
  MIDDLE_POSITION,
  CHICKLET_ORANGE,
  USER_SPECIFIED_OPTION
} from '../../constants';

const baseProto = {
  buildItem({ value, label }) {
    return value ? { value, label, option: this.id, category: this.category } : { option: this.id };
  },

  set selected(value) {
    this.selectedObject = this.buildItem(value);
    if (this.selectedObject)
      this.selectedObject.chickletLabel = this.chickletLabel(this.selectedObject.label);
  },

  get selected() {
    return this.selectedObject;
  },

  get selectedLabel() {
    return this.selectedObject ? this.selectedObject.label : '';
  },

  get selectedValue() {
    return this.selectedObject ? this.selectedObject.value : '';
  },

  loadDefaultValue() {
    return null;
  },

  chickletLabel(value) {
    const prefix = this.prefix || '';
    return prefix + String(value);
  },
};

const OptionFactory = {
  create(type) {
    return Object.assign(
      Object.create(baseProto),
      this.optionsMap[type],
      { key: type }
    );
  },

  setAnyDisplayName(name) {
    this.optionsMap[ANY].displayName = name;
  },

  setUserSpecifiedDisplayName(name) {
    this.optionsMap[USER_SPECIFIED_OPTION].displayName = name;
  },

  optionsMap: {
    [ANY]: {
      id: ANY,
      displayName: ANY,
      position: FIRST_POSITION,
    },
    [USER_SPECIFIED_OPTION]: {
      id: USER_SPECIFIED_OPTION,
      displayName: 'Search...',
      position: LAST_POSITION,
    },
  },

};

export default OptionFactory;

export const isValidOption = option => (Object.keys(OptionFactory.optionsMap).indexOf(option) >= 0);

export const defaultOptions = [ANY, USER_SPECIFIED_OPTION];

export const buildCustomOption = ({ value, label }) => {
  return Object.assign(
    Object.create(baseProto),
    {
      id: value,
      displayName: label,
      key: value,
      position: MIDDLE_POSITION,
      loadDefaultValue() {
        this.selected = { value, label };
        return true;
      },
    });
};



// WEBPACK FOOTER //
// ./app/components/KdSelectEntity/options.js